import { OnboardingStyles } from "features/onboarding/common/styles";
import { SELECT_EXCHANGE_PRIMARY_TITLE } from "@shared/features/onboarding/constants";
import Flex from "common/Boxes/Flex";
import SelectExchange from "features/portfolio/CreateAccount/SelectExchange";
import useMedia from "utils/hooks/useMedia";
import { MOBILE_SEARCH } from "common/constants";
import LoadingSpinnerOverlay from "common/Overlays/LoadingSpinnerOverlay";
import { useContext } from "react";
import { QuickConnectContext } from "@shared/features/onboarding/QuickConnect.context";
import useQuery from "utils/hooks/useQuery";

interface OnboardingSelectExchangeProps {
  onSelectExchange: (primaryExchange: string) => void;
}

const OnboardingSelectExchange = ({
  onSelectExchange,
}: OnboardingSelectExchangeProps) => {
  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);
  const { quickConnectLoading, code, state } =
    useContext(QuickConnectContext) || {};
  const query = useQuery();
  const exchange = query.get("exchange");
  const isQuickConnect =
    (!!query.get("state") && !!query.get("conn_code")) || (!!code && !!state);

  return (
    <Flex $flexDirection="column" style={{ width: "100%", maxWidth: 1000 }}>
      <LoadingSpinnerOverlay
        isLoading={quickConnectLoading || isQuickConnect}
        hideContentWhileLoading={
          quickConnectLoading || isQuickConnect || !exchange
        }
        wrapStyle={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {!isMobile && (
          <OnboardingStyles.Title>
            {SELECT_EXCHANGE_PRIMARY_TITLE}
          </OnboardingStyles.Title>
        )}
        <SelectExchange
          isOnboarding={true}
          onSelectExchange={onSelectExchange}
        />
      </LoadingSpinnerOverlay>
    </Flex>
  );
};

export default OnboardingSelectExchange;
